module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div id=\"progressTitle\" class=\"prop-header\">\r\n    <span class=\"prop-label\">Progress Settings</span>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 prop-sublabel\">\r\n        <input id=\"autoValue\" type=\"checkbox\" name=\"autoValue\">\r\n        <span>Automatically show page progress</span>\r\n    </div>\r\n</div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-35\">Value</label> \r\n            <div>\r\n                <input id=\"progressValue\" type=\"number\" min=\"0\" max=\"100\" name=\"value\" value=\"")
    ; __append(escapeFn( value ))
    ; __append("\" />\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}